import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export const buildWorkCenterForm = (formBuilder: UntypedFormBuilder): UntypedFormGroup => {
  return formBuilder.group({
    id: ['', Validators.required],
    name: ['', Validators.required],
    number: ['', Validators.required],
  });
};
